<template>
  <div v-show="homeScreenStatus" class="home">
    <Subject name="math" />
    <div id="clown-home"></div>
    <div class="container">
      <div class="title">
        <div class="title--clown">CLOWN</div>
        <div class="title--to">TO</div>
        <div class="title--water">WATER</div>
        <img class="title--drop-left" src="@/assets/practices/clown_to_water/drop_left.svg" alt="drop" />
        <img class="title--drop-right" src="@/assets/practices/clown_to_water/drop_right.svg" alt="drop" />
      </div>
    </div>
    <img
      src="@/assets/practices/clown_to_water/button_start.svg"
      alt="start"
      class="button--start"
      @click="runInstructions"
    />

    <!-- <img
      class="button"
      src="@/assets/practices/clown_to_water/button_start.svg"
      alt="start"
      @click="runInstructions"
      v-show="!instructions"
    />
    <img
      class="button"
      src="@/assets/practices/clown_to_water/button_next.svg"
      alt="next"
      @click="nextInstructions"
      v-show="instructions && (instructionsPage !== 3) "
    />
    <img
      class="button"
      src="@/assets/practices/clown_to_water/button_start.svg"
      alt="start"
      @click="startGame"
      v-show="instructionsPage === 3"
    />
    <div id="clown-home" v-show="!instructions"></div>

    <div class="sliders" v-show="!instructions">
      <div id="front"></div>
      <div id="front-shadow"></div>
      <div id="mid"></div>
      <div id="mid-shadow"></div>
      <div id="back"></div>
      <div id="back-shadow"></div>
      <img id="bubble" src="@/assets/practices/clown_to_water/sidebar_bubble.svg" alt="bubble" />
      <h1 class="title">Saving Money</h1>
    </div>-->

    <!-- <div class="instructions" v-if="instructions">
      <Slider :pageOneIsOpen="pageOneIsOpen" :pageTwoIsOpen="pageTwoIsOpen">
        <template v-slot:first-page v-if="instructionsPage === 0">
          <div class="text">
            <h1 class="title">Instructions</h1>
            <p>Let's play to save money! Notice the characteristics of each coin:</p>
            <p class="special">
              <span style="color: #FF585E">Color</span> -
              <span style="color: #D9FF58">Size</span> -
              <span style="color: #B758FF">Value</span>
            </p>
            <p>You will learn to count money easily. Let's have fun saving!</p>
          </div>
        </template>
        <template v-slot:first-page v-else-if="instructionsPage === 1">
          <div class="text">
            <h1 class="title">Instructions</h1>
            <p>Insert in each pig the amount of coins by selecting each coin and dragging it to the corresponding little pig.</p>
          </div>
        </template>
        <template v-slot:first-page v-else>
          <div class="text">
            <h2 class="title">Instructions</h2>
            <p>Know the value of each currency below:</p>
            <div id="coins-simple">
              <CoinSimple name="Penny" type="penny" value="1 ¢" />
              <CoinSimple name="Nickel" type="nickel" value="5 ¢" />
              <CoinSimple name="Dime" type="dime" value="10 ¢" />
              <CoinSimple name="Quarter" type="quarter" value="25 ¢" />
            </div>
          </div>
        </template>
        <template v-slot:second-page v-show="instructions">
          <div class="text">
            <h2 class="title">Example</h2>
            <p
              class="question"
            >Insert in each little pig the number of coins requested: 5 pennies and 2 dimes.</p>
          </div>
          <Demo />
        </template>
      </Slider>
    </div>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Home',
  components: {
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  data: () => ({
    animationActive: false,
    instructions: false,
  }),
  computed: {
    ...mapGetters({
      homeScreenStatus: 'clownToWater/homeScreenStatus',
    }),
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById('clown-home'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/assets/practices/clown_to_water/animations/clown_home.json',
    });
  },
  methods: {
    ...mapActions({
      homeClickStart: 'clownToWater/homeClickStart',
    }),
    nextInstructions() {
      sounds.globalButton.play();
      if (!this.animationActive) {
        this.animationActive = true;
        if (this.instructionsPage <= 1) {
          this.pageOneIsOpen = false;
          this.pageTwoIsOpen = false;
          setTimeout(() => {
            this.instructionsPage += 1;
            this.pageOneIsOpen = true;
            this.pageTwoIsOpen = true;
            this.animationActive = false;
          }, 2000);
        }
        if (this.instructionsPage === 2) {
          this.pageOneIsOpen = false;
          this.animationActive = false;
          this.instructionsPage += 1;
        }
      }
    },
    resetLocalData() {
      this.animationActive = false;
      this.instructions = false;
      this.instructionsPage = 0;
      this.pageOneIsOpen = true;
      this.pageTwoIsOpen = true;
    },
    runInstructions() {
      sounds.globalButton.play();
      this.homeClickStart();
      // this.instructions = true;
      // console.log('Clicked instructions start button.');
    },
    startGame() {
      sounds.globalButton.play();
      this.pageOneIsOpen = false;
      this.pageTwoIsOpen = false;
      setTimeout(() => {
        this.resetLocalData();
        this.homeClickStart();
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.home {
  @include flex-center;
  height: 100vh;
  position: absolute;
  width: 100vw;

  .button--start {
    bottom: 5vh;
    height: 2em;
    position: absolute;
    right: 5vh;
  }

  .container {
    @include flex-center;
    background-color: #f8f8f8;
    border: 0.4em solid #ac1818;
    border-radius: 75px;
    height: 60vh;
    position: relative;
    transform: perspective(60vw) rotateY(-15deg) translate(5vw, 0);
    width: 60vw;
  }

  .title {
    display: grid;
    font-family: Splatch, sans-serif;
    font-size: 3.5em;
    grid-template:
      'clown clown clown'
      'to water none'
      'drop-left water drop-right';
    position: absolute;
    right: 5%;
    text-shadow: 0.05em 0.05em 10px #000000aa;
    -webkit-text-stroke-color: #ffffff;
    width: min-content;
    z-index: 2;

    * {
      text-align: center;
      padding: 0.2em;
    }

    &--clown {
      color: #bfdb00;
      grid-area: clown;
      -webkit-text-stroke-width: 0.05em;
    }

    &--to {
      color: #7c19c6;
      font-size: 25%;
      grid-area: to;
      -webkit-text-stroke-width: 0.075em;
    }

    &--water {
      font-size: 75%;
      grid-area: water;
      -webkit-text-stroke-width: 0.05em;
    }

    &--drop-left,
    &--drop-right {
      font-size: 25%;
      height: 2.5em;
    }

    &--drop-left {
      grid-area: drop-left;
    }

    &--drop-right {
      grid-area: drop-right;
    }
  }

  #clown-home {
    height: 75vh;
    position: absolute;
    transform: translate(-30vw, 0);
    width: 75vh;
    z-index: 1;
  }
}

@media (max-aspect-ratio: 8/5) {
  .home {
    .container {
      height: 50vh;
      transform: perspective(60vw) rotateY(-15deg) translate(7.5vw, 0);
    }

    .title {
      font-size: 2.25em;
    }
  }
}
</style>
